import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { TermsBody } from "@/components/TermsBody";
import { Loader2, Check, ExternalLink } from "lucide-react";

export const TermsDialog = ({ open, onOpenChange, onAgree }) => {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    if (open && !terms) api.get("/terms").then((r) => setTerms(r.data)).catch(() => {});
  }, [open, terms]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl p-0 gap-0 bg-white overflow-hidden" data-testid="terms-dialog">
        <div className="bg-spark-teal-deep text-white px-6 py-5 border-b-4 border-spark-yellow">
          <DialogTitle className="font-display uppercase tracking-tight text-xl sm:text-2xl font-bold">{terms?.title || "Terms and Conditions of Service"}</DialogTitle>
          <DialogDescription className="text-slate-300 text-sm mt-1">{terms ? `Last updated: ${terms.last_updated}` : "Loading…"}</DialogDescription>
        </div>
        <div className="max-h-[60vh] overflow-y-auto px-5 sm:px-6 py-5" data-testid="terms-dialog-body">
          {!terms ? (
            <div className="flex justify-center py-10"><Loader2 className="size-6 animate-spin text-spark-teal" /></div>
          ) : <TermsBody terms={terms} compact />}
        </div>
        <div className="flex flex-wrap items-center justify-between gap-2 px-6 py-4 border-t border-spark-line bg-spark-floor">
          <a href="/terms" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-xs text-spark-teal-dark underline" data-testid="terms-dialog-open-page">Open full page <ExternalLink className="size-3" /></a>
          <div className="flex gap-2">
            <button type="button" onClick={() => onOpenChange(false)} className="px-4 py-2 rounded-md text-xs uppercase tracking-wider font-semibold text-spark-slate hover:bg-white" data-testid="terms-dialog-close">Close</button>
            {onAgree && (
              <button type="button" onClick={onAgree} disabled={!terms} className="btn-accent text-xs" data-testid="terms-dialog-agree">
                <Check className="size-4" /> I agree
              </button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
